if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.gallerySliderEl = this.querySelector('.product__media-list-wrap');
        this.flickityInstance = null;

        // Initialisation Flickity sur la galerie principale
        if (this.gallerySliderEl && typeof Flickity === 'function') {
          this.flickityInstance = new Flickity(this.gallerySliderEl, {
            cellSelector: '.product__media-item',
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: false
          });
        }

        // Détection retardée du slider Flickity des thumbnails
        if (this.elements.thumbnails) {
          setTimeout(() => {
            const flickitySlider = this.elements.thumbnails.querySelector('.flickity-slider');
            if (flickitySlider) {
              this.elements.thumbnails.slider = flickitySlider;
              this.flickityReady = true;
            } else {
              console.warn('⚠️ flickity-slider introuvable');
              this.flickityReady = false;
            }
          }, 300);
        }

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        // Ajout des événements sur les vignettes
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
          const btn = mediaToSwitch.querySelector('button');
          if (!btn) return;

          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const mediaId = mediaToSwitch.dataset.target;

            if (this.flickityInstance) {
              this.flickityInstance.select(index);
            } else {
              this.setActiveMedia(mediaId, false);
            }
          });
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        if (activeMedia.classList) activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages?.();
        }

        this.preventStickyHeader();

        setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }

          const rect = activeMedia.getBoundingClientRect();
          if (rect.top > -0.5) return;

          window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((btn) =>
          btn.removeAttribute('aria-current')
        );
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);

        // Scroll to active thumbnail only if not visible
        setTimeout(() => {
          const container = this.elements.thumbnails.slider || this.elements.thumbnails;
          if (!container) return;

          const isVisible = (thumb, offset = 10) => {
            const rect = thumb.getBoundingClientRect();
            return rect.left + offset >= 0 && rect.right - offset <= window.innerWidth;
          };

          if (!isVisible(thumbnail)) {
            container.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
            if (!this.flickityReady) {
              console.warn('⚠️ Slider non trouvé, fallback sur thumbnails');
            }
          }
        }, 0);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia?.loadContent) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}